import {generateFetchOptions} from '../index';

// POST /api/v1/applicants/:applicant_id/onboarding/start
export async function start(applicantId: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/applicants/${applicantId}/onboarding/start`,
    generateFetchOptions({
      method: 'POST',
      isProtected: true,
    })
  );
}
